/**
 * List of US cities that are supported in the platform
 * These cities will have special handling for filtering and display
 */
export const US_CITIES = [
  'miami',
  'orlando',
  'tampa',
  'fort lauderdale',
  'west palm beach'
] as const

/**
 * Check if a city is a US city (case-insensitive)
 */
export const isUSCity = (city: string | null | undefined): boolean => {
  if (!city) return false
  return US_CITIES.includes(city.toLowerCase() as typeof US_CITIES[number])
}

export type USCity = typeof US_CITIES[number]
